<template>
    <div id="actualites">
        <Header />

        <div class="container">
            <div id="carouselHacked" class="carousel slide carousel-fade" data-ride="carousel">
                <div class="carousel-inner">
                    <div v-for="(slide, index) in slides" :key="index" class="item"
                        :class="{ active: index === currentIndex }">
                        <img :src="slide.image" class="img-responsive" :alt="slide.title">
                        <div class="carousel-caption">
                            <h4>{{ slide.title }}</h4>
                        </div>
                    </div>
                </div>
                <!-- Left and Right controls -->
                <a class="left carousel-control" href="#carouselHacked" data-slide="prev">
                    <span class="glyphicon glyphicon-chevron-left"></span>
                </a>
                <a class="right carousel-control" href="#carouselHacked" data-slide="next">
                    <span class="glyphicon glyphicon-chevron-right"></span>
                </a>
            </div>

            <div class="row" style="margin-top: 30px;">
                <div class="col-sm-8">
                    <div class="article-content">
                        <h3 class="text-center">Hommage et Gratitude : L’Excellence au Service de la Médecine Générale,
                            Médecine de Famille</h3>

                        <p class="text-justify">
                            Sous le sceau du savoir et de l’engagement indéfectible envers l’élévation de la science
                            médicale, il me revient l’honneur et le privilège d’exprimer, dans toute la solennité
                            requise, ma profonde gratitude envers celles et ceux dont le dévouement et l’expertise ont
                            contribué à faire de cet événement un jalon historique.
                        </p>

                        <p class="text-justify">
                            Tenue du <strong>15 au 16 mai 2025</strong> au sein de l’éminente <strong>Faculté de
                                Médecine d’Oran</strong>, cette rencontre prestigieuse, placée sous l’égide du thème
                            fondamental <em>« Innovations et défis pour des soins de qualité »</em>, a incarné avec
                            éclat les aspirations les plus élevées du corps médical.
                        </p>

                        <h3>Un Engagement Institutionnel au Service de la Nation</h3>

                        <p class="text-justify">
                            À <strong>Monsieur le Wali d’Oran</strong>, dont le haut patronage témoigne du soutien
                            indéfectible de l’État algérien à la noble cause de la santé et à l’élévation du corps
                            médical, nous adressons nos salutations les plus respectueuses. Son engagement, reflet de la
                            grandeur de notre nation, demeure une source d’inspiration pour tous les artisans du progrès
                            sanitaire.
                        </p>

                        <p class="text-justify">
                            Nos plus vifs remerciements vont également à <strong>Monsieur le Doyen de la Faculté de
                                Médecine d’Oran</strong>, à <strong>Madame la Professeure, Chef de Département de
                                Médecine</strong>, à <strong>Monsieur le Secrétaire Général</strong>, ainsi qu’à
                            l’ensemble des personnels administratifs, techniques et de sécurité, dont la rigueur et le
                            dévouement ont conféré à cet événement le sceau de l’excellence académique.
                        </p>

                        <h3>Les Bâtisseurs de l’Architecture Sanitaire Moderne</h3>

                        <p class="text-justify">
                            Nous saluons avec déférence <strong>Messieurs les Directeurs de l’Exécutif de la Wilaya
                                d’Oran</strong>, en particulier <strong>Monsieur le Directeur de la Santé</strong>, dont
                            le professionnalisme et la vision stratégique sont les garants d’un avenir sanitaire
                            prometteur.
                        </p>

                        <p class="text-justify">
                            À <strong>Monsieur le Directeur du CHUO</strong>, à <strong>Monsieur le Président du Conseil
                                Scientifique du CHUO</strong> et son adjoint, ainsi qu’à <strong>Monsieur le Directeur
                                des Activités Médicales et Paramédicales du CHUO</strong>, nous rendons hommage pour
                            leur inestimable contribution à l’essor et à l’excellence du système hospitalier.
                        </p>

                        <h3>Un Héritage Médical Élevé au Rang d’Excellence</h3>

                        <p class="text-justify">
                            Le <strong>Conseil de l’Ordre des Médecins - Région d’Oran</strong>, représenté par son
                            Président, témoigne de l’accompagnement essentiel du corps médical dans l’exercice de ses
                            nobles missions quotidiennes.
                        </p>

                        <p class="text-justify">
                            Nos <strong>Maîtres Professeurs</strong>, ainsi que les <strong>Chefs de Service du CHUO et
                                de l’EHUO</strong>, par la richesse de leur savoir et la noblesse de leur mission
                            pédagogique, constituent un socle inaltérable pour l’élévation de la médecine.
                        </p>

                        <p class="text-justify">
                            À nos brillants <strong>orateurs et communicants</strong>, dont l’engagement exemplaire a
                            transcendé cet événement, nous exprimons une gratitude infinie.
                        </p>

                        <p class="text-justify">
                            Nous nous inclinons avec respect devant <strong>Monsieur le Président de la Société
                                Algérienne de Médecine Générale (SAMG)</strong> et ses éminents membres, dont la rigueur
                            et le dévouement forgent les fondations de notre discipline.
                        </p>

                        <p class="text-justify">
                            Aux <strong>doyens médecins généralistes</strong>, nos aînés qui nous ont honorés par leur
                            présence et leur soutien, faisant le lien entre le passé et le présent.
                        </p>

                        <h3>L’Avenir Médical : Une Lignée de Gardiens du Savoir</h3>

                        <p class="text-justify">
                            Aux <strong>étudiants en médecine</strong>, futurs piliers du savoir médical et garants de
                            son perpétuel renouveau, nous adressons notre confiance absolue. Vous êtes les porteurs
                            d’une flamme inextinguible, celle du progrès et de l’innovation médicale, assurant la
                            liaison entre le présent et l’avenir.
                        </p>

                        <p class="text-justify">
                            Nos <strong>sponsors</strong>, dont l’inestimable contribution et la présence indéfectible
                            ont marqué ces premières journées médicales.
                        </p>

                        <p class="text-justify">
                            Nos <strong>participants</strong>, venus de toutes les régions de notre cher pays,
                            l’Algérie, dont la présence a conféré à cette rencontre une portée nationale indiscutable.
                        </p>
                        <h1></h1>
                        <h1></h1>
                    </div>
                </div>
                <div class="col-sm-4" style="background: aliceblue;padding-top:7px">
                    <div v-for="(img, index) in sideImages" :key="index" class="mb-3"
                        style="margin-bottom: 15px; height: 200px !important; height: inherit; padding: 0px !important;">
                        <img :src="img.src" :alt="img.alt" class="img-responsive img-thumbnail"
                            style="padding:0; max-height:350px">
                    </div>

                    <h1></h1>
                    <hr>
                    <h1></h1>

                    <div>
                        <h4 style="margin-top: 10px;"></h4>

                        <div v-for="(video, index) in videos" :key="index" class="row video-row"
                            @click="openVideo(video.url)">
                            <div class="video-card" @click="openVideo(video.url)">
                                <div class="col-xs-6">
                                    <div class="thumbnail-container">
                                        <img :src="video.image" class="img-responsive video-thumbnail"
                                            :alt="video.title" />
                                        <div class="play-icon">&#9658;</div>
                                    </div>
                                </div>

                                <div class="col-xs-6">
                                    <p class="video-title">{{ video.title }}</p>
                                </div>
                                <p style="text-align: right">{{ video.subtitle }}</p>
                            </div>
                        </div>

                        <img src="/assets/actualites/Photos/6.jpg" height="250px" style="padding: 7px">
                    </div>



                </div>
            </div>

            <div class="row">
                <div class="col-sm-12" style="padding: 0px">
                    <div class="carousel-container">
                        <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li v-for="(chunk, index) in imageChunks" :key="index"
                                    :data-target="'#carousel-example-generic'" :data-slide-to="index"
                                    :class="{ active: index === 0 }"></li>
                            </ol>

                            <div class="carousel-inner" role="listbox">
                                <div v-for="(chunk, index) in imageChunks" :key="index"
                                    :class="['item', { active: index === currentIndex }]">
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-2" v-for="(image, i) in chunk" :key="i">
                                            <img :src="image" class="img-responsive center-block"
                                                @click="openImage(image)" style="height: 150px !important" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <a class="left carousel-control" href="#carousel-example-generic" role="button"
                                data-slide="prev">
                                <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="right carousel-control" href="#carousel-example-generic" role="button"
                                data-slide="next">
                                <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isModalOpen" class="modal-overlay">
                <div class="modal-content">
                    <span class="close" @click="closeModal">&times;</span>
                    <img :src="selectedImage" class="modal-image" />
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
export default {
    name: "Hommage",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            selectedImage: null,
            isModalOpen: false,
            currentIndex: 0,
            slides: [
                {
                    image: "/assets/actualites/Photos/3.jpg",
                    title: "Titre 3",
                    description: "Description de l’image 3.",
                },
                {
                    image: "/assets/actualites/Photos/7.jpg",
                    title: "Titre 7",
                    description: "Description de l’image 7.",
                },
                {
                    image: "/assets/actualites/Photos/8.jpg",
                    title: "Titre 8",
                    description: "Description de l’image 8.",
                },
                {
                    image: "/assets/actualites/Photos/9.jpg",
                    title: "Titre 9",
                    description: "Description de l’image 9.",
                },
                {
                    image: "/assets/actualites/Photos/12.jpg",
                    title: "Titre 12",
                    description: "Description de l’image 12.",
                }
            ],
            images: [
                "/assets/actualites/Photos/1.jpg",
                "/assets/actualites/Photos/2.jpg",
                "/assets/actualites/Photos/3.jpg",
                "/assets/actualites/Photos/4.jpg",
                "/assets/actualites/Photos/5.jpg",
                "/assets/actualites/Photos/6.jpg",
                "/assets/actualites/Photos/7.jpg",
                "/assets/actualites/Photos/8.jpg",
                "/assets/actualites/Photos/9.jpg",
                "/assets/actualites/Photos/10.jpg",
                "/assets/actualites/Photos/11.jpg",
                "/assets/actualites/Photos/12.jpg",
                "/assets/actualites/Photos/13.jpg",
                "/assets/actualites/Photos/14.jpg",
                "/assets/actualites/Photos/15.jpg",
                "/assets/actualites/Photos/16.jpg",
                "/assets/actualites/Photos/17.jpg",
                "/assets/actualites/Photos/18.jpg",
                "/assets/actualites/Photos/19.jpg",
                "/assets/actualites/Photos/20.jpg",
                "/assets/actualites/Photos/21.jpg",
                "/assets/actualites/Photos/22.jpg",
                "/assets/actualites/Photos/23.jpg",
                "/assets/actualites/Photos/24.jpg",
                "/assets/actualites/Photos/25.jpg",
                "/assets/actualites/Photos/26.jpg",
                "/assets/actualites/Photos/27.jpg",
                "/assets/actualites/Photos/28.jpg",
                "/assets/actualites/Photos/29.jpg",
                "/assets/actualites/Photos/30.jpg",
                "/assets/actualites/Photos/31.jpg",
                "/assets/actualites/Photos/32.jpg",
                "/assets/actualites/Photos/33.jpg",
                "/assets/actualites/Photos/34.jpg",
                "/assets/actualites/Photos/35.jpg",
                "/assets/actualites/Photos/36.jpg",
                "/assets/actualites/Photos/37.jpg",
                "/assets/actualites/Photos/38.jpg",
                "/assets/actualites/Photos/39.jpg",
                "/assets/actualites/Photos/40.jpg",
                "/assets/actualites/Photos/41.jpg",
                "/assets/actualites/Photos/42.jpg",
                "/assets/actualites/Photos/43.jpg",
                "/assets/actualites/Photos/44.jpg",
                "/assets/actualites/Photos/45.jpg",
            ],
            sideImages: [
                {
                    src: "/assets/actualites/Photos/13.jpg",
                },
                {
                    src: "/assets/actualites/Photos/3.jpg",
                },

            ],
            videos: [
                {
                    url: "https://www.facebook.com/share/v/1EXFU1twya/",
                    title: "جمعية الأطباء العامين - أطباء الأسرة لوهران وبالتعاون مع الجمعية الجزائرية للطب العام تنظم الأيام الطبية الأولى بكلية الطب بوهران",
                    subtitle: '',
                    image: '/assets/actualites/videos/1.png'
                },
                {
                    url: "https://www.facebook.com/share/v/16JcHwjDWX/",
                    title: 'وهران | الأيام العلمية الأولى للطب العام؛ تحت شعار: "الابتكارات والتحديات من أجل رعاية ذات جودة"',
                    subtitle: "من تنظيم جمعية الأطباء العامين وأطباء الأسرة بوهران (AMGO) بالتعاون مع الجمعية الجزائرية للطب العام على مستوى #كلية_الطب", image: '/assets/actualites/videos/2.png'
                },
                {
                    url: "https://www.facebook.com/BahiaTvOran/videos/23977068405222225/?mibextid=9drbnH",
                    title: "وهران : انطلاق الايام الطبية الأولى بكلية الطب",
                    subtitle: '',
                    image: '/assets/actualites/videos/3.png'
                },
            ],
        };
    },
    methods: {
        generateEmbedUrl(videoUrl) {
            const encodedUrl = encodeURIComponent(videoUrl);
            return `https://www.facebook.com/plugins/video.php?href=${encodedUrl}&show_text=0&width=560`;
        },
        openVideo(videoUrl) {
            window.open(videoUrl, "_blank");
        },
        openImage(image) {
            this.selectedImage = image;
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
            this.selectedImage = null;
        },
    },
    computed: {
        imageChunks() {
            const chunkSize = 5;
            let chunks = [];
            for (let i = 0; i < this.images.length; i += chunkSize) {
                chunks.push(this.images.slice(i, i + chunkSize));
            }
            return chunks;
        },
    },
    mounted() {
        setInterval(() => {
            this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        }, 3000);

        // Carousel is handled by Vue's currentIndex + setInterval above
    }
};
</script>
<style scoped>
.carousel-control .glyphicon-chevron-left,
.carousel-control .icon-prev {
    font-size: 18px;
    padding: 5px;
    background: #42b3e5;
    border-radius: 50%;
    color: #fff;
    margin-left: 0;
    margin-top: auto;
}

.carousel-control .glyphicon-chevron-right,
.carousel-control .icon-next {
    font-size: 18px;
    padding: 5px;
    background: #42b3e5;
    border-radius: 50%;
    color: #fff;
    margin-left: 0;
    margin-top: auto;
}

.carousel-container {
    /* width: 350px; */
    margin: 0 auto;
}

.carousel-inner>.item>.row {
    display: flex;
    justify-content: space-between;
}

.carousel-inner>.item>.row>.col-xs-12 {
    padding: 5px;
}

.carousel-inner>.item>img {
    max-width: 100%;
    height: auto;
}

.carousel-inner {
    background: #fff !important;
}

.video-card {
    cursor: pointer;
    transition: transform 0.2s;
}

.video-card:hover {
    transform: scale(1.01);
}

.thumbnail-container {
    position: relative;
}

.video-thumbnail {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.video-row {
    margin-bottom: 20px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
}

.thumbnail-container {
    position: relative;
    max-width: 100%;
}

.video-thumbnail {
    width: 100%;
    max-width: 200px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 32px;
    color: white;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
    pointer-events: none;
}

.video-title {
    font-size: 13px;
    font-weight: bold;
    color: #333;
    line-height: 1.5;
    margin-top: 10px;
    text-align: right;
    /* good for Arabic-style text */
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.modal-content {
    position: relative;
    background-color: #fff;
    padding: 20px;
    max-width: 75%;
    max-height: 85%;
    padding: 7px;
    overflow-y: auto;
    margin-top: 25px;
}

.modal-image {
    width: 100%;
    height: auto;
}

.close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 30px;
    cursor: pointer;
    padding: 1px 9px 4px 9px;
    background: #0096df;
    border-radius: 19px;
    color: #fff;
}
</style>